// Simple API client for invitation operations
// The actual business logic is in /backend_auth/services/invitationService.js
import { API_BASE_URL } from '../config';

const AUTH_API_BASE_URL = API_BASE_URL;

export const invitationsAPI = {
  /**
   * Get all invitations for the current user's organization
   */
  async getInvitations(authToken) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/invitations`, { headers });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to fetch invitations';
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  /**
   * Send a new invitation
   */
  async sendInvitation(invitationData, authToken) {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/invite`, {
      method: 'POST',
      headers,
      body: JSON.stringify(invitationData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to send invitation';
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  /**
   * Delete an invitation
   */
  async deleteInvitation(invitationId, authToken) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/invitations/${invitationId}`, {
      method: 'DELETE',
      headers
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to delete invitation';
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  /**
   * Resend an invitation
   */
  async resendInvitation(invitationId, authToken) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/invitations/${invitationId}/resend`, {
      method: 'POST',
      headers
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to resend invitation';
      throw new Error(errorMessage);
    }

    return await response.json();
  }
};

// Export as default for backward compatibility
export default invitationsAPI;
